import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {
  private isHttpLoadingSubject = new BehaviorSubject<boolean>(false);
  isHttpLoading$ = this.isHttpLoadingSubject.asObservable();

  private isManualLoadingSubject = new BehaviorSubject<boolean>(false);
  isManualLoading$ = this.isManualLoadingSubject.asObservable();

  setHttpLoading(isHttpLoading: boolean) {
    this.isHttpLoadingSubject.next(isHttpLoading);
  }

  setManualLoading(isLoading: boolean) {
    this.isManualLoadingSubject.next(isLoading);
  }
}
